import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Correct import for useNavigate
import './Header.css';
import logo from './assets/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isHomePage = location.pathname === '/';

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (target) => {
    setIsMenuOpen(false); // Close the menu
    navigate('/'); // Navigate to the main page
    setTimeout(() => {
      document.getElementById(target).scrollIntoView({ behavior: 'smooth' });
    }, 100); // Delay to ensure navigation before scrolling
  };

  return (
    <header className={`header ${(!isHomePage || isScrolled) ? 'scrolled' : ''}`}>
      <div className="logo">
        <img src={logo} onClick={() => handleNavClick('home')} alt="Logo" />
      </div>
      <button className="menu-toggle" onClick={toggleMenu}>
        ☰
      </button>
      <nav className={isMenuOpen ? 'nav-links open' : 'nav-links'}>
        <button className="nav-link" onClick={() => handleNavClick('home')}>HOME</button>
        <button className="nav-link" onClick={() => handleNavClick('about')}>ABOUT</button>
        <button className="nav-link" onClick={() => handleNavClick('products')}>PRODUCTS</button>
        <button className="nav-link" onClick={() => handleNavClick('contact')}>CONTACT</button>
      </nav>
    </header>
  );
};

export default Header;
